<!-- // footer section \\ -->
<section class="footer-section">
  <div class="comman-width">
    <div class="row">
      <div class="footer-adjust">
        <div class="col-lg-2 col-md-2 col-sm-3 first">
          <h2 class="HonestDiscountFooter">{{ brandName }}</h2>
          <ul class="footer-nav">
            <li>
              <a class="cool-link" routerLink="/Home" routerLinkActive="active"
                >Home<span>&nbsp;</span></a
              >
            </li>
            <!-- <li>
              <a
                class="cool-link"
                routerLink="/aboutUs"
                routerLinkActive="active"
                >About Us<span>&nbsp;</span></a
              >
            </li> -->
            <!-- <li>
              <a
                class="cool-link"
                [routerLink]="['/howItWorks']"
                routerLinkActive="active"
                >How it works<span>&nbsp;</span></a
              >
            </li> -->
            <li>
              <a
                class="cool-link"
                routerLink="/contact"
                routerLinkActive="active"
                >Contact Us<span>&nbsp;</span></a
              >
            </li>
            <!-- <li>
              <a
                class="cool-link"
                routerLink="#"
                routerLinkActive="active"
                >Program Description<span>&nbsp;</span></a
              >
            </li> -->
            <li>
              <a
                class="cool-link"
                routerLink="/MyCards"
                routerLinkActive="active"
                >My Cards<span>&nbsp;</span></a
              >
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 second">
          <ul>
            <!-- <li>
              <a class="cool-link" [routerLink]="['/download-mobile-app']" (click)="slideToggle()" routerLinkActive="active"
                >Download Mobile App<span>&nbsp;</span></a
              >
            </li> -->
            <li>
              <a class="cool-link" 
              [routerLink]="['/help']" routerLinkActive="active"
                >Help<span>&nbsp;</span></a
              >
            </li>
            <li>
              <a class="cool-link" 
              [routerLink]="['/terms-and-conditions']" routerLinkActive="active"
                >Terms of Use<span>&nbsp;</span></a
              >
            </li>
            <li>
              <a class="cool-link" 
              [routerLink]="['/drugs-covered']" routerLinkActive="active"
                >Drugs Covered <span>&nbsp;</span></a
              >
            </li>
            <li><a href="#">Consumer CCPA Privacy Notice at Collection</a></li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-4 third">
          <!-- <a href="#" class="logo"
            ><img src="assets/images/logo.png" alt="hdrx-logo"
          /></a>
          <h2>
            Subscribe to our Newsletter<span
              >Neque porro quisquam est qui dolorem ipsum</span
            >
          </h2> -->

          <!-- <form name="submit-to-google-sheet" id="submit-to-google-sheet">                     -->
          <!-- <input
            name="email_"
            type="email"
            class="form-control newsLetter"
            placeholder="Enter Email address"
            required
            (keyup)="removeerror($event)"
          />
          <span id="newsvalidator" style="display:none">{{ newserror }}</span>
          <button
            type="submit"
            id="submit-form"
            value="Submit"
            (click)="newsletter()"
            class="btn btn-hover-effect"
          >
            <div class="insider"></div>
            Submit
          </button> -->
          <!-- </form> -->
          <!-- <div class="alert alert-danger">Please enter email</div>
          <div class="alert alert-success">
            <strong>Thank you</strong> for subscribing.
          </div> -->
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 fourth">
          <h2>Follow {{ brandName }}</h2>
          <ul class="social">
            <!-- <li>
              <img src="../../../assets/images/facebook.svg" />
              <a class="cool-link" href="#">Facebook</a>
            </li> -->
            <li>
              <img src="../../../assets/images/linked-in.svg" />
              <a class="cool-link" href="https://www.linkedin.com/company/little-angel-hands/">Linked In</a>
            </li>
            <!-- <li>
              <img src="../../../assets/images/twitter.svg" />
              <a class="cool-link" href="#">Twitter</a>
            </li> -->
            <li>
              <img src="../../../assets/images/email.svg" />
              <a class="cool-link" href="mailto: {{brandEmail}}">Email</a>
            </li>
          </ul>
          <h2 class="RxHackerDiscountFooter column-title">Get your discount card</h2>
          <div class="walletDiv">
            <div class="discountWallet" (click)="openpass(applegenericpassval)"  *ngIf="ios">
              <img src="../../assets/images/apple_wallet.png">
              <span>Add to Apple wallet</span>
            </div>
            <div class="discountWallet google-wall" (click)="openpass(googlegenericpassval)" *ngIf="android">
              <img src="../../assets/images/google_wallet.png">
              <span>Add to Google wallet</span>
            </div>    
          </div>
        </div>
      </div>
      </div>
  </div>
  <div class="foot_discla_bord"></div>
  <div class="comman-width">
    <p>Pharmacy names, logos, brands, and other trademarks are the property of their respective owners.</p>
    <p><strong>The {{ brandName }} prescription discount program is NOT insurance</strong>. It is also not a Medicare prescription drug plan. The range of prescription discounts provided under this discount program will vary depending on the prescription and pharmacy where the prescription is purchased and can be up to 80% off the retail price. <strong>Purchases using the Bounty Health LLC program do not count towards insurance or Medicare deductibles or out-of-pocket maximums.</strong> You are fully responsible for paying your prescriptions at the pharmacy at the time of service, but you will be entitled to receive a discount from the pharmacy in accordance with the specific pre-negotiated discounted rate schedule. Bounty Health LLC is the Administrator of the {{ brandName }} Hands prescription discount program with its office located at Bounty Health LLC, PO Box 1703, Allen, TX 75013. and email at <a href="mailto:support@RxHacker.com">support@RxHacker.com</a>. For additional information, including an up-to-date list of pharmacies and covered drugs, or assistance with any problems related to this prescription drug discount plan, please contact our member support line toll free at visit <a href="/">{{ brandUrl }}</a>. By using the {{ brandName }} Hands prescription discount program or app, you agree to the {{ brandName }} Hands Terms and Conditions found at <a href="./terms">https://www.{{ brandUrl }}/terms</a>.</p>
  </div>
  <div class="copyright">
    <div class="comman-width">
      <ul>
        <li>
          <a class="cool-link" [routerLink]="['/terms-and-conditions']" routerLinkActive="active">Terms of Use<span>&nbsp;</span></a>
        </li>
        <li>
          <a class="cool-link" [routerLink]="['/privacy-policy']" routerLinkActive="active">Privacy<span>&nbsp;</span></a>
        </li>
        <li>© 2024 {{ brandName }}. All rights reserved.</li>
      </ul>
    </div>
  </div>
</section>
<!-- \\ footer section // -->
